import React from 'react';
import './MessengerImageSendModeModal.css';
import { Modal } from '@/components/ui/Modal/Modal';

export type MessengerImageSendModeChoice = 'attachment' | 'compressed_image';

interface MessengerImageSendModeModalProps {
  open: boolean;
  fileCount: number;
  onClose: () => void;
  onChoose: (mode: MessengerImageSendModeChoice) => void;
}

export function MessengerImageSendModeModal({
  open,
  fileCount,
  onClose,
  onChoose,
}: MessengerImageSendModeModalProps): React.ReactNode {
  const title =
    fileCount > 1 ? `Как отправить ${fileCount} изображения?` : 'Как отправить изображение?';

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      headerVariant="island"
      containedOverlay
    >
      <p className="messengerImageSendModeModal__hint">
        Только для вставки из буфера и перетаскивания. «Как вложение» — в ленте ссылка без превью
        (тип в сообщении не image/*). «Как изображение» — сжатие в JFIF и превью в чате.
      </p>
      <div className="messengerImageSendModeModal__actions">
        <button
          type="button"
          className="messengerImageSendModeModal__btn messengerImageSendModeModal__btn_primary"
          onClick={() => onChoose('attachment')}
        >
          Как вложение
        </button>
        <button
          type="button"
          className="messengerImageSendModeModal__btn"
          onClick={() => onChoose('compressed_image')}
        >
          Как изображение (сжатие)
        </button>
      </div>
    </Modal>
  );
}
